import { ArrowLittleRightIcon, Button, Flex } from '@joinrepublic/dls-ui-kit';

import { FADE_CAP_WIDTH } from '../sector-chips-row/constants';
import { IScrollArrowButtonProps } from './types';

/**
 * Scroll control for the sector row, rendered as an overlay so it never changes
 * the scroller's own width — that width is what decides whether the arrow should
 * be visible at all, so an inline button would feed back into its own condition.
 *
 * DLS has no left chevron, so the left arrow is the right one rotated.
 */
export const ScrollArrowButton = ({
  direction,
  onClick,
}: IScrollArrowButtonProps) => {
  const isLeft = direction === 'left';

  return (
    <Flex
      position="absolute"
      top="0"
      bottom="0"
      left={isLeft ? '0' : undefined}
      right={isLeft ? undefined : '0'}
      width={FADE_CAP_WIDTH}
      align="center"
      justify={isLeft ? 'flex-start' : 'flex-end'}
      // The gradient cap is pointer-transparent so touch drags pass through it to
      // the scroller underneath; only the button itself takes pointer events.
      pointerEvents="none"
      bgGradient={
        isLeft
          ? 'linear(to-l, transparent 34%, neutral.bg-primary 77%)'
          : 'linear(to-r, transparent 34%, neutral.bg-primary 77%)'
      }
    >
      <Button
        variant="neutral-secondary"
        size="sm"
        aria-label={isLeft ? 'Scroll sectors left' : 'Scroll sectors right'}
        onClick={onClick}
        pointerEvents="auto"
      >
        <ArrowLittleRightIcon
          boxSize="4"
          transform={isLeft ? 'rotate(180deg)' : undefined}
        />
      </Button>
    </Flex>
  );
};
